import { Card, CardBody, CardHeader } from '../components/ui';
import { MarkdownContent } from '../components/MarkdownContent';
import helpMarkdown from '../../helpfaq.md?raw';

export default function HelpPage() {
  return (
    <div className="grid grid-cols-1 gap-4">
      <Card>
        <CardHeader title="Help & FAQ" />
        <CardBody>
          <MarkdownContent markdown={helpMarkdown} />
        </CardBody>
      </Card>
    </div>
  );
}
